module.exports = __webpack_public_path__ + "fonts/Ki.31f3692c.eot";